import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Button, Tabs, Tab } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import _ from 'lodash';
import ReactDOM from 'react-dom';
import moment from 'moment'
import { handlePutInSubmit } from '../../../actions/sales_actions';
import { DateFormatter2 } from '../../Common/dateFormat';
import { isCCW } from '../../../actions/root_url';

const ESCAPE_KEY = 27;
const ENTER_KEY = 13;

const { Selectors } = Data;

export class BatchModal extends Component {
  constructor() {
    super();
    this.state = {
      quantityRemaining: 0,
      
      changed: false,
      oldLoaded: 0,
      
      batches: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
        editedRows: [],
      },

      qtyPair: null,
      package_date: moment(new Date()).format("MM-DD-YY"),
      weight: '',
    }
  }

  // returnTotalWeight={ this.returnTotalWeight.bind(this) }
  // keepLoaded={this.keepLoaded}
  // oldLoaded={this.state.oldQuantity}
  componentDidMount() {

    this.props.fetchBatches();
    // if (this.props.batchesInfo && this.props.batchesInfo.batches.length) {
    //   // here somwtime ProductNum is undefined
    //   // const {
    //   //   batches,
    //   // } = this.props.generateBatchRelatedInfo(this.props.selectedInventoryRow.ProductNum)
      
    //   const {
    //     batches,
    //   } = this.props.generateBatchRelatedInfo(this.props.rowProduct)
      
    //   this.initializeModal(batches);
    // }
    // // document.addEventListener("keydown", this._handleKeyDown);
    
 
    // ReactDOM.findDOMNode(this.refs['TotalWeight'].getRenderedComponent().myInput.refs.input).focus();
    // ReactDOM.findDOMNode(this.refs['Ref'].getRenderedComponent()).focus();
    // ReactDOM.findDOMNode(this.refs['Ref']).focus();
  }
  
  componentWillUnmount() {
    // document.removeEventListener("keydown", this._handleKeyDown);
    if (!this.state.changed) {
      this.props.keepLoaded(this.props.oldLoaded || this.state.oldLoaded);
    }
  }

  _handleKeyDown = (event) => {
    switch (event.keyCode) {
      case ENTER_KEY:
        this.handleOnSubmit();
        break;
      default:
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
    // after putin new batch, cache the current remaing qty and qty and re init the data
    if (nextProps.batchesInfo !== this.props.batchesInfo && nextProps.batchesInfo.batches.length) {
      if (!this.state.batches.rows.length)  {
        const {
          batches,
        } = this.props.generateBatchRelatedInfo(this.props.rowProduct)
        this.initializeModal(batches)
        return;
      }
      const {
        batches,
      } = this.props.generateBatchRelatedInfo(this.props.rowProduct)
      this.initializeModal(batches)

      const qtyPair = {};
      this.state.batches.rows.forEach(row => {
        qtyPair[row['batchId']] = row.quantity;
      });
      this.setState({
        qtyPair,
        keepRemainingqty: this.state.quantityRemaining,
      }, () => {
        const {
          batches,
        } = this.props.generateBatchRelatedInfo(this.props.rowProduct)
        this.initializeModal(batches)
      })
    }
  }
  
  initializeModal = (array) => {
    const { selectedInventoryRow } = this.props;
    const IsOverSaleable = selectedInventoryRow ? selectedInventoryRow.IsOverSaleable : false;

    let index = 0;
    let formatter = [];
    let quantityRemaining = this.props.quantityValue;

    // after put in new batch, keep the current remaining quantity and loaded qty
    if (this.state.qtyPair) {
      quantityRemaining = this.state.keepRemainingqty
    }
    if (array && array.length > 0) {
      array.map(r => {
        let qty = 0;
        if (this.state.qtyPair && this.state.qtyPair[r.id]) {
          qty = this.state.qtyPair[r.id]
        }
        // if (r.quantity >= quantityRemaining) {
        //   qty = quantityRemaining;
        //   quantityRemaining = 0;
        // } else {
        //   if (r.quantity >= 0) {
        //     qty = r.quantity;
        //     quantityRemaining -= r.quantity;
        //   }
        // }
        formatter.push({ Idx: index++, batchId: r.id, quantity: qty,
          expire_datetime: r.expire_datetime, location: r.location, 
          batch_num: r.batch_num, availableQty: r.quantity,
          is_initial_batch: r.is_initial_batch, case_per_layer: r.case_per_layer,
          layer_per_pallet: r.layer_per_pallet, avg_wt: r.avg_wt, package_date: r.package_date
        });
      })
    } else {
      formatter = [];
      // formatter.push({ Idx: 0, batchId: null, quantity: "0", expire_datetime: null, location: null, batch_num: null, availableQty: null });
    }
    if ((quantityRemaining && IsOverSaleable)) {
      // const initialBatchIndex = _.findIndex(formatter, batch => batch.is_initial_batch);
      // formatter[initialBatchIndex].quantity += parseInt(quantityRemaining);
      // quantityRemaining = 0;
    }
    const batches = {
      ...this.state.batches,
      rows: formatter,
      editedRows: [],
    }
    this.setState({
      batches,
      quantityRemaining,
    });
  }

  handleOnSubmit = (e) => {
    const { rows } = this.state.batches;
    let totalWeight = 0;
    const batchRows = [];
    let isErrorWt = false;
    let sumQty = 0;
    rows.map((row) => {
      if (row.quantity>0) {
        if (row.avg_wt>0) {
          totalWeight += parseFloat(row.avg_wt)* row.quantity;
        } else {
          isErrorWt = true;
        }
        sumQty += Number(row.quantity);
        batchRows.push({
          Batch_id_id: row.batchId,
          BatchExpiredDate: row.expire_datetime,
          BatchLocation: row.location,
          BatchQty: row.quantity,
          BatchAveWt: row.avg_wt,
        });
      }
    });

    if(isErrorWt) {
      alert('The batch weight is incorrect. Please go to the inventory page to modify it!')
      return
    }
    if(sumQty < Number(this.props.quantityValue)) {
      alert('Qty is less than your loaded Qty.');
      return
    }
    this.props.returnBatch(totalWeight.toFixed(2), batchRows);
    this.setState({ changed: true }, () => { this.props.closeC(); });
  };

  // this only works on the left table
  onClickAddAll(idx) {
    const { selectedInventoryRow, selectedproductRow } = this.props;
    const { IsOverSaleable } = selectedInventoryRow;
    let { quantityRemaining } = this.state;
    let { rows } = this.state.batches;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        if (r.availableQty >= quantityRemaining || (IsOverSaleable && r.is_initial_batch)) {
          rows[index].quantity = quantityRemaining;
          quantityRemaining = 0;
        } else {
          rows[index].quantity = r.availableQty;
          quantityRemaining = Number(quantityRemaining) - Number(r.availableQty);
        }
      }
    });
    const batches = { ...this.state.batches, rows }
    this.setState({ batches, quantityRemaining });
  }
  
  onClickRemoveAll(idx) {
    let { quantityRemaining } = this.state;
    let { rows } = this.state.batches;
    rows.map((r, index) => {
      if (r.Idx === idx) {
        quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
        rows[index].quantity = 0;
      }
    });
    const batches = {
      ...this.state.batches,
      rows,
    }
    this.setState({ batches, quantityRemaining });
  }
  
  renderBatchTable() {
    const getRows = () => {
      return Selectors.getRows(this.state.batches);
    }
    const getSize = () => {
      return getRows().length;
    }
    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }

    const handleRowUpdated = e => {
      const { IsOverSaleable } = this.props.selectedInventoryRow;
      
      this.setState({ sortColumn: null, sortDirection: null })
      let { quantityRemaining } = this.state;
      let rows = getRows();

      let editedRows = this.state.batches.editedRows.slice(0);
      const line = rows[e.rowIdx];
      const canExceed = IsOverSaleable && line.is_initial_batch;
      if (e.updated && e.updated.quantity > line.availableQty && !canExceed) {
        alert("Cannot exceed available quantity.");
        return;
      } else if (e.updated && e.updated.quantity > quantityRemaining) {
        alert("Cannot exceed remaining quantity.");
        return;
      } else if ((Number(e.updated.quantity) !== Number(rows[e.rowIdx].quantity))) {
        this.setState({ quantityRemaining: Number(this.state.quantityRemaining) + Number(rows[e.rowIdx].quantity) - Number(e.updated.quantity) });
      }
      Object.assign(rows[e.rowIdx], e.updated);
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx)
          editedRows.splice(index, 1)
      }, this);
      editedRows.push(rows[e.rowIdx]);
      
      const batches = {
        ...this.state.batches,
        // rows,
        editedRows
      }
      this.setState({ batches });
    }
    
    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.batches.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const batches = { ...this.state.batches, filters: newFilters }
      this.setState({ batches });
    };

    const onClearFilters = () => {
      const batches = { ...this.state.batches, filters: {} }
      this.setState({ batches });
    };
    
    const handleGridSort = (sortColumn, sortDirection) => {
      const batches = { ...this.state.batches, sortColumn, sortDirection };
      this.setState({ batches });
    };
    
    const columns = [
      {
        key: 'Idx',
        name: <Translate value="operation" />,
        resizable: true,
        width: 100,
        formatter: ({ value, dependentValues }) => (
          <div
            style={{ width: '100%' }}
          >
            <span onClick={() => {
              this.onClickAddAll(value);
            }}
              style={{ cursor: "pointer", color: "green", marginRight: '12px' }}
            >+All</span>
            <span 
              onClick={() => {this.onClickRemoveAll(value)}}
              style={{ cursor: "pointer", color: "red" }}
            >-All</span>
          </div>
        ),
        width: 100,
        getRowMetaData: (row) => row,
      },
      {
        key: 'quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 90,
      },
      {
        key: 'availableQty',
        name: <Translate value="available" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
      {
        key: 'expire_datetime',
        name: <Translate value="expired" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        getRowMetaData: row => row,
        formatter: ({ value }) => {
          if (value) {
            let currentTime = moment();
            const dateTime = moment(value);
            const date= dateTime.format("MM-DD-YY");
            if(dateTime.isAfter(currentTime)) {
              return <span>{date}</span>
            } else {
              return <div style={{ textAlign: 'center', backgroundColor: "#FA9696"}}>
                <span>{date}</span>
                </div>
            }
          }
          return <span className="label label-danger">-</span>;
        },
      },
      {
        key: 'location',
        name: <Translate value="location" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
      },
      {
        key: 'batch_num',
        name: <Translate value="batch_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
      },
      {
        key: 'package_date',
        name: <Translate value="pack_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 120,
        formatter: DateFormatter2,
      },
      {
        key: 'avg_wt',
        name: <Translate value="avg_wt" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 90,
      },
    ]

    return (
      <Row>
        <label style={{ color: 'orange', fontSize: '15px' }}><Translate value="quantity_remaining" />: {this.state.quantityRemaining}</label>
        <Col>
          <div style={{ maxWidth: '850px', marginLeft: '25px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', }}>
              {this.renderAddBatch()}
            </div>
            <ReactDataGrid
              // rowKey="Idx"
              enableCellSelect={true}
              rowRenderer={<RowRenderer />}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={300}
              rowHeight={25}
              headerRowHeight={45}
              onRowUpdated={handleRowUpdated}
              toolbar={<Toolbar enableFilter />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              onGridSort={handleGridSort}
            />
          </div>
        </Col>
      </Row>
    )
  }

  handlePutinBatchClick = () => {
    const {
      package_date,
      weight,
    } = this.state;
    if (!weight || !package_date) return;
    if (package_date.length !== 8) {
      alert('package date format is MM-DD-YY');
      return;
    }
    // const { selectedProductIdCCW } = this.props;
    // console.log('this.props', this.props);
    // return;
    const success = () => {
      alert('put in success');
      this.setState({
        weight: '',
        // package_date: '',
      });
      this.props.fetchBatches();
      return;
    }
    const failed = (response) => {
      let msg = 'unable to put in';
      if (response) {
        msg = JSON.stringify(response);
      }
      alert(msg);
      return;
    }
    this.props.handlePutInSubmit(this.state.package_date, this.state.weight, success, failed)
    // inventory/relocation_v2_mulit_warehouse_lap/
    // handlePutInSubmit(payload, success, failed)
  }

  renderAddBatch = () => {
    if (isCCW) {
      const inputStyle = {
        border: '1px solid black',
        borderRadius: '5px',
        // padding: '0px 5px 0px 5px',
        width: '140px',
        marginRight: '10px',
        marginLeft: '3px',
        padding: '10px',
      }
      const labelStyle = {
        fontWeight: 'bold',
        fontSize: '16px',
        justifyContent: 'center',
        alignItem: 'center'
      }
      return <div style={{ display: 'flex', flexDirection: 'row', height: '25px' }}>
        <p style={labelStyle}>Weight:</p> <input onChange={e => this.setState({ weight: e.target.value})} value={this.state.weight} style={inputStyle} placeholder='weight: lbs' />
        {/* <p style={labelStyle}>Pack date: </p><input onChange={e => this.setState({ package_date: e.target.value })} value={this.state.package_date} style={inputStyle} placeholder='MM-DD-YY' /><p style={{ color: 'red' }}>(date format MM-DD-YY)</p> */}
        <Button
          bsStyle="primary"
          onClick={() => {
            this.handlePutinBatchClick()
          }}
          style={{ marginRight: '5px', marginLeft: '5px' }}
        >
          <span>Add</span>
        </Button>
      </div>
    }
  }

  handleRemoveAll = () => {
    let { quantityRemaining } = this.state;
    let { rows } = this.state.batches;
    
    rows.map((r, index) => {
      quantityRemaining = Number(quantityRemaining) + Number(rows[index].quantity);
      rows[index].quantity = 0;
    });
    
    let rowNew = rows;
    let quantityRemainingNew = quantityRemaining;
  
    const batches1 = {
      ...this.state.batches,
      rows: [],
    }
    this.setState({ batches: batches1 }, () => {
      const batches2 = {
        ...this.state.batches,
        rows: rowNew,
      }
      this.setState({ batches: batches2, quantityRemaining: quantityRemainingNew });
    });
  }

  render() {
    return (
      <div>
        <Row ref='Ref'>
          <Col className="text-center">
            <span>
              {this.renderBatchTable()}
            </span>
          </Col>
        </Row>
        <Row className="centerStyle" style={{ marginTop: '20px' }}>
          <Button
            bsStyle="danger"
            onClick={() => { this.handleRemoveAll() }}
            style={{ marginRight: '5px' }}
          >
            <span>Remove All</span>
          </Button>
          <Button
            style={{ marginRight: '5px' }}
            bsStyle="success"
            onClick={(e) => { this.handleOnSubmit(e); }}
          >
            <Translate value="add_batches" />
          </Button>
        </Row>
      </div>
    );
  }
}

class RowRenderer extends Component {
  render() {
    return (
      <div style={{color:'black'}}>
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

export default BatchModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/components/BatchModal.jsx